export default {
  install (Vue) {
    Vue.filter('nullable', (value, text = '–') => {
      return (value === null || value === undefined || value === '') ? text : value
    })

    Vue.filter('capability', (value, strengthText = 'Strength') => {
      const capabilities = [
        {
          value: 'strength',
          text: strengthText
        },
        {
          value: 'meets',
          text: 'Meets'
        },
        {
          value: 'requires_development',
          text: 'Requires development'
        },
        {
          value: 'not_observed',
          text: 'Not observed'
        }
      ]

      const capability = capabilities.find(capability => capability.value === value)

      return capability === undefined ? null : capability.text
    })
  }
}
